require('normalize.css/normalize.css');

require('styles/main.css');


import React from 'react';
import {Nav} from './Nav/Nav';
import {Header} from './Header/Header';
import {Introduction} from './Introduction/Introduction';
import {CommentMarche} from './CommentMarche/CommentMarche';
import {AppProfile} from './AppProfile/AppProfile';
import {Footer} from './Footer/Footer';
import { translate, Trans } from 'react-i18next';


class Home extends React.Component {
  component
  render() {
    return (
      <div>
      <Nav/>
      <Header/>
      <Introduction/>
      <CommentMarche/>
      <AppProfile/>
      <Footer/>
     </div>
    );
  }
}

Home.defaultProps = {
};

export default Home;
 


// WEBPACK FOOTER //
// ./src/components/Home.js